/**
 * DynamoDB table identifiers + sort-key prefixes Kingpin relies on. Split out
 * from the original `KingpinConstants.ts` so the constants live alongside
 * data access code without dragging the unrelated UI palette / route map
 * into the service.
 */
import { NORMALIZED_STAGE } from 'src/constants/EnvironmentConstants';

export const KINGPIN_GOALS_TABLE = 'finsuite_kingpin_goals';

export const KINGPIN_LEADER_GOALS_TABLE = `finsuite_kingpin_leader_goals_${NORMALIZED_STAGE}`;

export const SNAPSHOT_LATEST_SK = 'SNAPSHOT#LATEST';
export const SNAPSHOT_SK_PREFIX = 'SNAPSHOT#';
export const REGISTRY_SK = 'REGISTRY';
export const SYNC_PK = 'SYNC';

export const STALE_DAYS = 30;
export const APPROACHING_DUE_DAYS = 90;
export const DUE_SOON_DAYS = 30;
export const MOM_LOOKBACK_DAYS = 30;
